module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon19.c31b7ed4.png";